import { render, staticRenderFns } from "./UserAuthorization.vue?vue&type=template&id=8f1d9562"
import script from "./UserAuthorization.vue?vue&type=script&lang=js"
export * from "./UserAuthorization.vue?vue&type=script&lang=js"
import style0 from "./UserAuthorization.vue?vue&type=style&index=0&id=8f1d9562&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports